import React, { useEffect, useState } from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from './Captchalibcode';
import styles from './Captcha.scss';
import Icon from '../../../../modules/react/components/stateless/Icon';
import { captchaStatus } from './constants';
import useCurrentPage from '../../../hooks/useCurrentPage';

const Captcha = ({ validate, resetCaptcha }) => {
  const [captchaInput, setCaptchaInput] = useState('');
  const [verificationStatus, setVerificationStatus] = useState(captchaStatus.NOT_VERIFIED);
  const { buttonStyleClass } = useCurrentPage();

  const handleRefresh = () => {
    setCaptchaInput('');
    setVerificationStatus(captchaStatus.NOT_VERIFIED);
    validate(false);
    loadCaptchaEnginge(6);
  };

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  useEffect(() => {
    setVerificationStatus(captchaStatus.NOT_VERIFIED);
    validate(false);
  }, [resetCaptcha]);

  const handleApplied = () => {
    setCaptchaInput('');
  };

  const handleVerify = () => {
    const isCaptchaValid = validateCaptcha(captchaInput);
    setVerificationStatus(isCaptchaValid ? captchaStatus.VERIFIED : captchaStatus.FAILED);
    validate(captchaInput);
    if (isCaptchaValid) {
      handleApplied();
    }
  };

  return (
    <div className={styles.captchaContainer}>
      {verificationStatus === captchaStatus.VERIFIED && (
        <div className={styles.successMessage}>
          <Icon id="misc2" label="Success" className={styles.successIcon} />
          <span className={styles.message}>Thank you! Your response has been verified.</span>
        </div>
      )}
      {(verificationStatus === captchaStatus.NOT_VERIFIED
        || verificationStatus === captchaStatus.FAILED) && (
        <>
          <div className={styles.captchaText}>
            To continue, please complete the CAPTCHA below.
            This helps us prevent automated programs (bots) from accessing the site.
            If you are having trouble, refresh the CAPTCHA to try a different one.
          </div>
          <div className={styles.captchaWrapper}>
            <div className={styles.captchaCanvas}>
              <LoadCanvasTemplateNoReload />
            </div>
            <button
              type="button"
              className={styles.captchaRefreshButton}
              onClick={handleRefresh}
              title="Refresh Captcha"
            >
              <div className={styles.captchaRefreshButton}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                  <polyline points="23 4 23 10 17 10" />
                  <polyline points="1 20 1 14 7 14" />
                  <path d="M3.51 9a9 9 0 0114.68-4.71L23 10M1 14l5.79 5.71A9 9 0 0020.49 15" />
                  </svg>
              </div>

            </button>
          </div>
        </>
      )}
      <div className={styles.captchaInfo}>
        <div className={styles.captcha}>
          CAPTCHA TEXT <span className={styles.captcharequired}>*</span>
        </div>
        { verificationStatus === captchaStatus.FAILED && (
          <div className={styles.errorMessage}>
            We could not verify your Captcha. Please try again.
          </div>
        )}
        <div className={styles.captchaInputContainer}>
          <input
            type="text"
            value={captchaInput}
            placeholder="Enter Captcha"
            className={styles.captchaInput}
            onChange={e => setCaptchaInput(e.target.value)}
            disabled={verificationStatus === captchaStatus.VERIFIED}
          />
          <button
            type="button"
            className={`${verificationStatus === captchaStatus.VERIFIED
              ? styles.captchaAppliedButton
              : styles.captchaVerifyButton} ${buttonStyleClass}`}
            onClick={handleVerify}
            disabled={verificationStatus === captchaStatus.VERIFIED}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

Captcha.defaultProps = {
  required: false,
};

export default Captcha;
